import styled from 'styled-components';

export const StyledGroupContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ styleProps }) => styleProps?.backgroundColor};
  border-color: ${({ styleProps }) => styleProps?.borderColor};
  border-style: ${({ styleProps }) => styleProps?.borderStyle};
  border-radius: ${({ styleProps }) => styleProps?.borderRadius};
  border-width: ${({ styleProps }) => styleProps?.borderSize};

  position: relative;
  display: flex;
  flex-direction: column;
`;

export const StyledGroupHeader = styled.div`
  padding: 3px 8px;
  flex-shrink: 0;
  background-color: ${({ styleProps }) => styleProps?.backgroundColor};
  color: ${({ styleProps }) => styleProps?.color};
  font-family: ${({ styleProps }) => styleProps?.fontFamily};
  font-size: ${({ styleProps }) => styleProps?.fontSize};
  font-weight: ${({ styleProps }) => styleProps?.fontWeight};
  text-align: ${({ styleProps }) => styleProps?.textAlign};
  height: ${({ styleProps }) => styleProps?.height};
  display: flex;
  align-items: center;
`;

export const GroupChildrenContainer = styled.div`
  flex-grow: 1;
  padding: 5px;
`;